var path = '/templates/projects.settings/users/submenu.html';
var html = "<ul class=config-submenu-list><li ui-sref=admin.projects.settings.users() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><a>{{ 'projectsSettings.users.submenu.menbaa_kanri' | translate }}</a></li><li ui-sref=admin.projects.settings.users.invite() ui-sref-opts=\"{reload: true}\" ui-sref-active-eq=active><a>{{ 'projectsSettings.users.submenu.menbaa_wo_shoutai' | translate }}</a></li></ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.settings/users/submenu.html
// module id = 1536
// module chunks = 0